module.exports = __webpack_public_path__ + "img/engineers.0e4f4947.png";